import { TrackedEvents, trackEvent } from 'analytics';
import { useTranslation } from 'i18n';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton } from 'ui';
import { ImageOutlined, PrecisionManufacturingOutlined } from 'ui/icons';

export const LoadingDetailsDataCard = ({
  isLoading,
  loadingTechnique,
  targetPayload,
  packedOn,
  loadingNotes,
  hasMedia,
}: {
  isLoading?: boolean;
  loadingTechnique?: string | null;
  targetPayload?: number | null;
  packedOn?: string | null;
  loadingNotes?: string | null;
  hasMedia: boolean;
}) => {
  const { t } = useTranslation('features');
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'Loading Details',
    });
    navigate('media?tab=loading');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton
              icon={<ImageOutlined />}
              label={t('dataCards.loadingDetails.actions.showMedia')}
              onClick={handleClickMedia}
            />
          ) : undefined,
          avatar: <PrecisionManufacturingOutlined />,
          title: t('dataCards.loadingDetails.title'),
        },
      }}
    >
      {loadingTechnique ? (
        <DataCard.Item title={t('dataCards.loadingDetails.fields.loadingTechnique')}>{loadingTechnique}</DataCard.Item>
      ) : null}
      {Boolean(targetPayload) && (
        <DataCard.Item title={t('dataCards.loadingDetails.fields.targetPayload')}>
          {t('dataCards.loadingDetails.values.targetPayloadMt', { values: { targetPayload } })}
        </DataCard.Item>
      )}
      {packedOn ? (
        <DataCard.Item title={t('dataCards.loadingDetails.fields.packedOn')}>{packedOn}</DataCard.Item>
      ) : null}
      {loadingNotes ? (
        <DataCard.Item title={t('dataCards.loadingDetails.fields.loadingNotes')} colSpan={12}>
          {loadingNotes}
        </DataCard.Item>
      ) : null}
    </DataCard>
  );
};
